export enum Route {
  About = '/about',
  Features = '/features',
  Home = '/',
  Pricing = '/pricing',
}
